<template>
  <div>
    投注站实战票交易记录
    <div class="header">
        <el-button type="primary">增加</el-button>
        <el-button type="primary">编辑</el-button>
        <el-button type="primary">删除</el-button>
        <el-button type="primary">回收站</el-button>
    </div>
    <el-table>
      <el-table-column label="序号"></el-table-column>
      <el-table-column label="众筹招股标题"></el-table-column>
      <el-table-column label="实战票"></el-table-column>
      <el-table-column label="众筹招股跳转链接"></el-table-column>
      <el-table-column label="兑奖每股价格"></el-table-column>
      <el-table-column label="股权兑奖情况(要求开奖14小时内完成)"></el-table-column>
      <el-table-column label="兑奖打款截图"></el-table-column>
      <el-table-column label="彩票代表和彩票经理"></el-table-column>
      <el-table-column label="操作"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>